/**
 * Private Mode Configuration
 *
 * When VITE_PRIVATE_MODE=true, the web client runs without Firebase auth,
 * cloud storage, or chat history. It connects directly to a private backend
 * using a static auth token.
 *
 * Environment variables:
 *   VITE_PRIVATE_MODE=true          — enable private mode
 *   VITE_API_BASE_URL               — backend URL (also sets vite proxy target)
 *   VITE_PRIVATE_PERSONA=pipar      — default persona
 *   VITE_PRIVATE_MODEL=             — AI model override (empty = backend default)
 *   VITE_PRIVATE_TTS_VOICE=         — TTS voice (empty = backend default)
 *   VITE_PRIVATE_TTS_MODEL=         — TTS model override (empty = backend default)
 */

export const PRIVATE_MODE = import.meta.env.VITE_PRIVATE_MODE === 'true'

export const PRIVATE_AUTH_TOKEN = 'webclient@private.local'

export const PRIVATE_PERSONA = import.meta.env.VITE_PRIVATE_PERSONA || 'pipar'

export const PRIVATE_MODEL = import.meta.env.VITE_PRIVATE_MODEL || ''

export const PRIVATE_TTS_VOICE = import.meta.env.VITE_PRIVATE_TTS_VOICE || ''

export const PRIVATE_TTS_MODEL = import.meta.env.VITE_PRIVATE_TTS_MODEL || ''
